import { useTranslation } from "react-i18next";
import { useInboxContext } from "context/InboxProvider";
import { useSidebarsContext } from "context/SidebarsProvider";
import { useDropdownMenu } from "hooks/useDropdownMenu";
import { paths } from "utils/paths";
import { ReactComponent as ReadAllIcon } from "assets/icons/double-check.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/tune.svg";

export const useInboxDropdown = () => {
  const { t } = useTranslation();
  const { isOpen, anchorEl, open, close } = useDropdownMenu();

  const { readAll } = useInboxContext();
  const { toggleSidebar, selected } = useSidebarsContext();

  const handleReadAll = () => {
    readAll();
  };

  const items = [
    {
      label: t("Inbox.Dropdown.Read", { count: 5 }),
      iconComponent: <ReadAllIcon width={20} height={20} />,
      onClick: handleReadAll,
    },
    {
      label: t("Inbox.Dropdown.NotificationSettings"),
      href: paths.settings.notifications,
      iconComponent: <SettingsIcon width={20} height={20} />,
      onClick: () => toggleSidebar(selected),
    },
  ];

  return { items, isOpen, anchorEl, open, close };
};
